"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getMyTeam = exports.setMyTeam = void 0;

var _BaseContainer = _interopRequireDefault(require("./BaseContainer"));

var CurrentTeamsContainer = _BaseContainer.default.create();

var MyTeamContainer = _BaseContainer.default.create();

var _setMyTeam = function setMyTeam(myTeamId) {
  MyTeamContainer.getContainer().set(myTeamId);
};

exports.setMyTeam = _setMyTeam;

var _getMyTeam = function getMyTeam() {
  return MyTeamContainer.getContainer().get();
};

exports.getMyTeam = _getMyTeam;

var _default = Object.assign(CurrentTeamsContainer, {
  setMyTeam: function setMyTeam(teamId) {
    return _setMyTeam(teamId);
  },
  getMyTeam: function getMyTeam() {
    return _getMyTeam();
  }
});

exports.default = _default;